<template>
  <div>
    <div v-if="isLoading" class="flex flex-row justify-center">
      <BaseLoader size="lg" />
    </div>
    <template v-if="!isLoading">
      <div
        class="flex flex-col mb-4"
        v-for="comment in comments"
        :key="comment.id"
      >
        <div class="flex flex-row">
          <div class="mr-3">{{ comment.user.full_name }}</div>
          <div class="text-sm text-metallicSilver">
            {{ comment.created_at }}
          </div>
        </div>
        <div class="px-4 py-2 bg-cultured rounded whitespace-pre-wrap">{{ comment.text }}</div>
      </div>
      <form>
        <BaseTextarea
          v-model="text"
          :has-error="hasError"
          placeholder="Текст комментария.."
        />
        <BaseError v-if="hasError">{{ error }}</BaseError>

        <BaseButton
          class="mt-2"
          size="sm"
          variant="blue"
          :disabled="formSending"
          @click="onSave"
        >
          <BaseLoader v-if="formSending" size="xs" class="mr-1" />
          Добавить
        </BaseButton>
      </form>
    </template>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  import WithHttpError from '@/components/mixins/WithHttpError';

  import BaseError from '@/components/global/base-error/index';
  import BaseButton from '@/components/global/base-button/index';
  import BaseLoader from '@/components/global/base-loader/index';
  import BaseTextarea from '@/components/global/base-textarea/index';

  export default {
    name: 'CommentList',

    components: {
      BaseError,
      BaseButton,
      BaseLoader,
      BaseTextarea,
    },

    mixins: [WithHttpError],

    props: {
      source: {
        required: true,
      },
      type: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        text: null,
        error: null,

        isLoading: true,
        formSending: false,
      };
    },

    computed: {
      ...mapState('Comment', ['comments']),

      hasError() {
        return this.error !== null;
      },
    },

    created() {
      this.$store.dispatch('Comment/loadComments', this.source).then(() => {
        this.isLoading = false;
      });
    },

    destroyed() {
      this.$store.dispatch('Comment/clear');
    },

    methods: {
      onSave() {
        if (!(!this.formSending && (this.formSending = true))) {
          return;
        }

        let data = {
          type: this.type,
          text: this.text,
          sourceId: this.source,
        };

        this.$store
          .dispatch('Comment/createComment', data)
          .then(() => {
            Object.assign(this, {
              text: null,
              error: null,
            });
          })
          .catch(this.prepareHttpError)
          .catch(() => {
            this.$store.commit('Notification/showAlert', {
              title: 'Ошибка!',
              message:
                'Произошла ошибка, пожалуйста попробуйте повторно отправить форму.',
            });
          })
          .finally(() => {
            this.formSending = false;
          });
      },
    },
  };
</script>
